import { render, staticRenderFns } from "./LifeSchoolEditItem.vue?vue&type=template&id=a35ef758"
import script from "./LifeSchoolEditItem.vue?vue&type=script&lang=js"
export * from "./LifeSchoolEditItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports